import { Tabs } from "antd";
import { useParams, useHistory } from "react-router";
import CustomizedOrdersCompany from "./CustomizedOrdersCompany";
import DirectOrdersCompany from "./DirectOrdersCompany";
import NormalOrdersCompany from "./NormalOrdersCompany";

const { TabPane } = Tabs;

const Client = () => {
  const history = useHistory();
  const params = useParams<any>();

  function callback(key: any) {
    history.push(`/all-clients/${params.id}/${key}`);
  }

  return (
    <div className="my_orders">
      <div className="container">
        <Tabs defaultActiveKey={params.tab_key} onChange={callback}>
          <TabPane tab="Direct Orders" key="1">
            <DirectOrdersCompany />
          </TabPane>
          <TabPane tab="Demco Orders" key="2">
            <NormalOrdersCompany />
          </TabPane>
          <TabPane tab="Customized Orders" key="3">
            <CustomizedOrdersCompany />
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
};

export default Client;
